/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'

import oauth2 from '../../http/requests/auth/oauth2/index.js'

import firebase from 'firebase/app'
import 'firebase/auth'
import router from '@/router'

export default {
  loginAttempt ({ dispatch }, payload) {

    // New payload for login action
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      closeAnimation: payload.closeAnimation
    }

    // If remember_me is enabled change firebase Persistence
    if (!payload.checkbox_remember_me) {

      // Change firebase Persistence
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)

      // If success try to login
        .then(function () {
          dispatch('login', newPayload)
        })

      // If error notify
        .catch(function (err) {

          // Close animation if passed as payload
          if (payload.closeAnimation) payload.closeAnimation()

          payload.notify({
            time: 2500,
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    } else {
      // Try to login
      dispatch('login', newPayload)
    }
  },
  login ({ commit, state, dispatch }, payload) {

    // If user is already logged in notify and exit
    if (state.isUserLoggedIn()) {
      // Close animation if passed as payload
      if (payload.closeAnimation) payload.closeAnimation()

      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })

      return false
    }

    // Try to sigin
    firebase.auth().signInWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)

      .then((result) => {

        // Set FLAG username update required for updating username
        let isUsernameUpdateRequired = false

        // if username is provided and updateUsername FLAG is true
        // set local username update FLAG to true
        // try to update username
        if (payload.updateUsername && payload.userDetails.displayName) {

          isUsernameUpdateRequired = true

          dispatch('updateUsername', {
            user: result.user,
            username: payload.userDetails.displayName,
            notify: payload.notify,
            isReloadRequired: true
          })
        }

        // Close animation if passed as payload
        if (payload.closeAnimation) payload.closeAnimation()

        // if username update is not required
        // just reload the page to get fresh data
        // set new user data in localstorage
        if (!isUsernameUpdateRequired) {
          router.push(router.currentRoute.query.to || '/')
          commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
        }
      }, (err) => {

        // Close animation if passed as payload
        if (payload.closeAnimation) payload.closeAnimation()

        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },
  /* eslint-disable */ 
 //oauth2 - adapted to arpa30 - USED
 loginOauth2({ commit }, payload) {
  return new Promise((resolve, reject) => {
    // SMS
    // oauth2.login(payload.email, payload.password)

    oauth2.loginQRFirstStep(payload.email, payload.password)
      .then(response => {
        // If there's user data in response
        if (response.data.data.userData) {
          localStorage.setItem('apiCode', JSON.stringify(response.data.data.apiCode))
          localStorage.setItem('userInfo', JSON.stringify(response.data.data.userData))
                  
          resolve(response)

        } else {
          reject({ message: 'Wrong Email or Password' })
        }
      })
      .catch(error => {
        reject(error)
      })
  })
},

//oauth2 - adapted to arpa30 - USED
loginOauth2SMSstep({ commit }, payload) {
  return new Promise((resolve, reject) => {
    // AUTHY
    oauth2.loginQRSecondStep(payload.apiCode, payload.code, payload.userId, payload.email)
      .then(response => {

        // // If there's user data in response
        if (response.data.data != null) {

          let user = response.data.data.userData

          localStorage.setItem('smsVerified', true)
          localStorage.setItem('loggedIn', true)

          if(user.role != '') {
            user.userRole = user.role
          }

          if(user.permissions && user.permissions.length > 0) {
            let permissionsCodes = []
            user.permissions.forEach(el => {
              if(el.allowed){
                permissionsCodes.push(el.code)
              }
            })
            user.permissionsCodes = permissionsCodes
          }
  
          // commit('UPDATE_USER_INFO', user, { root: true })
          commit('SET_USER_INFO', user, { root: true })
          resolve(response)

        } else {
          localStorage.setItem('smsVerified', false)

          reject({ message: 'Código segunda verificación erróneo' })
        }
      })
      .catch(error => {
        reject(error)
      })
  })
},

loginOauthTemporalAccessStep({ commit }, payload) {
  return new Promise((resolve, reject) => {

    oauth2.loginQRTemporalAccess(payload.userId, payload.token)
      .then(response => {

        // // If there's user data in response
        if (response.data.data != null) {

          let user = response.data.data.userData

          localStorage.setItem('smsVerified', true)
          localStorage.setItem('loggedIn', true)

          if(user.role != '') {
            user.userRole = user.role
          }

          if(user.permissions && user.permissions.length > 0) {
            let permissionsCodes = []
            user.permissions.forEach(el => {
              if(el.allowed){
                permissionsCodes.push(el.code)
              }
            })
            user.permissionsCodes = permissionsCodes
          }
  
          // commit('UPDATE_USER_INFO', user, { root: true })
          commit('SET_USER_INFO', user, { root: true })
          resolve(response)

        } else {
          localStorage.setItem('smsVerified', false)

          reject({ message: 'Código segunda verificación erróneo' })
        }
      })
      .catch(error => {
        reject(error)
      })
  })
},
// SSO genérico (ARPA ↔ CRM ↔ CMN): canjea un ticket de un solo uso por la sesión.
// Replica EXACTAMENTE el almacenamiento de loginOauth2SMSstep: go-arpa deja la
// cookie access_token (Set-Cookie en /sso/exchange, withCredentials) y devuelve el
// token en el body; con esa sesión pedimos /auth/me para el userData COMPLETO
// (permisos, rol, companyHasCrm…) y lo guardamos igual que el login normal.
ssoExchange({ commit }, payload) {
  return new Promise((resolve, reject) => {
    oauth2.ssoExchange(payload.ticket)
      .then(() => {
        // Sesión ya establecida por cookie; traer el userData completo como el login.
        oauth2.me()
          .then(response => {
            if (response.data.data != null && response.data.data.userData != null) {

              let user = response.data.data.userData

              localStorage.setItem('smsVerified', true)
              localStorage.setItem('loggedIn', true)

              if(user.role != '') {
                user.userRole = user.role
              }

              if(user.permissions && user.permissions.length > 0) {
                let permissionsCodes = []
                user.permissions.forEach(el => {
                  if(el.allowed){
                    permissionsCodes.push(el.code)
                  }
                })
                user.permissionsCodes = permissionsCodes
              }

              commit('SET_USER_INFO', user, { root: true })
              resolve(response)

            } else {
              reject({ message: 'No se pudo recuperar el perfil del usuario.' })
            }
          })
          .catch(error => { reject(error) })
      })
      .catch(error => { reject(error) })
  })
},

  // REVISAR

  //  //oauth2 - adapted to arpa30 - USED
  refreshTokenOauth2({ commit }, payload) {
    return new Promise((resolve, reject) => {

      oauth2.refreshToken()
      .then(response => {
        if (response.data.status == "success"){
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  // Google Login
  loginWithGoogle ({commit, state}, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    const provider = new firebase.auth.GoogleAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')
        commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  // Facebook Login
  loginWithFacebook ({commit, state}, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    const provider = new firebase.auth.FacebookAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')
        commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  // Twitter Login
  loginWithTwitter ({commit, state}, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    const provider = new firebase.auth.TwitterAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')
        commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  // Github Login
  loginWithGithub ({commit, state}, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    const provider = new firebase.auth.GithubAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')
        commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },
  registerUser ({dispatch}, payload) {

    // create user using firebase
    firebase.auth().createUserWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)
      .then(() => {
        payload.notify({
          title: 'Account Created',
          text: 'You are successfully registered!',
          iconPack: 'feather',
          icon: 'icon-check',
          color: 'success'
        })

        const newPayload = {
          userDetails: payload.userDetails,
          notify: payload.notify,
          updateUsername: true
        }
        dispatch('login', newPayload)
      }, (error) => {
        payload.notify({
          title: 'Error',
          text: error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },
  updateUsername ({ commit }, payload) {
    payload.user.updateProfile({
      displayName: payload.displayName
    }).then(() => {

      // If username update is success
      // update in localstorage
      const newUserData = Object.assign({}, payload.user.providerData[0])
      newUserData.displayName = payload.displayName
      commit('UPDATE_USER_INFO', newUserData, {root: true})

      // If reload is required to get fresh data after update
      // Reload current page
      if (payload.isReloadRequired) {
        router.push(router.currentRoute.query.to || '/')
      }
    }).catch((err) => {
      payload.notify({
        time: 8800,
        title: 'Error',
        text: err.message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    })
  },


  // JWT
  loginJWT ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload.userDetails.email, payload.userDetails.password)
        .then(response => {

          // If there's user data in response
          if (response.data.userData) {
            // Navigate User to homepage
            router.push(router.currentRoute.query.to || '/')

            // Quitado el token desde localStorage
            // Set accessToken
            // localStorage.setItem('accessToken', response.data.accessToken)

            // Update user details
            commit('UPDATE_USER_INFO', response.data.userData, {root: true})

            // Set bearer token in axios
            // commit('SET_BEARER', response.data.accessToken)

            resolve(response)
          } else {
            reject({message: 'Wrong Email or Password'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  registerUserJWT ({ commit }, payload) {

    const { displayName, email, password, confirmPassword } = payload.userDetails

    return new Promise((resolve, reject) => {

      // Check confirm password
      if (password !== confirmPassword) {
        reject({message: 'Password doesn\'t match. Please try again.'})
      }

      jwt.registerUser(displayName, email, password)
        .then(response => {
          // Redirect User
          router.push(router.currentRoute.query.to || '/')
          // Quitado el token desde localStorage
          // Update data in localStorage
          // localStorage.setItem('accessToken', response.data.accessToken)
          commit('UPDATE_USER_INFO', response.data.userData, {root: true})

          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchAccessToken () {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => { resolve(response) })
    })
  },

  // Check Token
  checkToken ({ dispatch }, error) {

    return new Promise((resolve) => {
      var errorToken = false
      var maintenance = false

      if (error.message == undefined) {
        errorToken = false
      } else {
        if((error.message.includes("Invalid access token")) ||
          (error.message.includes("access token expired")) ||
          (error.message.includes("authorization header not found")) ||
          (error.message.includes("incorrect authorization")) ||
          (error.message.includes("Unauthorized")) ||
          (error.message.includes("User logged in does not exist. Unauthorized")) ||
          (error.message.includes("Blacklisted token"))) {

            // DESCOMENTAR
            // localStorage.removeItem('accessToken')
            localStorage.removeItem('loggedIn')
            localStorage.clear()
            errorToken = true  
            // // jwt.refreshToken().then(response => { resolve(response) })


        } else {
          errorToken = false
          if (error.message.includes("maintenance") || error.message.includes("mantenimiento") ) {
            maintenance = true
          }
        }
      }  

      if (!errorToken && !maintenance) {
        resolve({message: 'Logged in!'})
      } else if (maintenance){
        // Ya se va a mantenimiento (sin logout automático). Sin resolve (seguiría el flujo) ni reject:
        // de 770 llamadas casi ninguna lo recoge y cada uno salía como error suelto.
        router.push({ path: '/e-prevision/maintenance' }).catch(() => {})
        return

      } else {
        // Ya se va al login: igual que arriba, la promesa se queda sin resolver a propósito.
        router.push({ path: '/e-prevision/login-eprevision' }).catch(() => {})
      }
    })
  },

  
}

